import { z } from 'zod';

export enum ClientType {
  HOST = 'HOST',
  PLAYER = 'PLAYER',
  REMOTE_CLIENT = 'REMOTE_CLIENT',
  REMOTE_HOST = 'REMOTE_HOST',
  OBSERVER = 'OBSERVER',
}

export const clientTypeSchema = z.nativeEnum(ClientType);
